<template>
  <TargetedModalView>
    <template v-slot:target="{ show }">
      <div class="clickable bg-secondary p-4 rounded-4" :class="{ 'border border-1 border-danger': errors != null }" @click="show">
        <div class="d-flex align-items-center justify-content-between">
          <div class="w-100">
            <div class="d-flex align-items-center">
              <i :class="selectedAction.icon" class="fa-lg"></i>
              <span class="ms-3">{{ selectedAction.title }}</span>
            </div>
            <div v-if="selectedAction.description" class="text-muted small mt-2">
              {{ selectedAction.description }}
            </div>
          </div>
          <div v-if="selectedAction.module" class="d-flex align-items-center g-1 rounded-3 bg-secondary fw-bold p-2 small" style="word-break: keep-all;">
            <i :class="selectedAction.module.icon" class="fa-fw"></i> <span>{{ selectedAction.module.name }}</span>
          </div>
        </div>
        <InputErrorsView v-if="errors?.key && errors.key.length > 0" class="mt-2 small" :errors="errors.key"/>
      </div>
    </template>
    <template v-slot:header="{ hide }">
      <div class="d-flex align-items-center justify-content-between">
        <h3 class="mb-0">{{ selectedAction.title }}</h3>
        <ModalCloseButtonView @click="hide"/>
      </div>
    </template>
    <template v-slot:body="{ hide }">
      <div class="d-flex flex-column g-4">
        <ParameterForm v-for="parameter in selectedAction.parameters" :key="parameter.key" :trigger="trigger" :action="selectedAction" :community-id="communityId" :data-types="dataTypes" :parameter="parameter" :value="value?.parameters ? value.parameters[parameter.key] : undefined" :errors="errors?.parameters ? errors.parameters[parameter.key] : undefined" @update:value="updateValue(item => item.parameters[parameter.key] = $event)"/>
        <div class="d-flex align-items-center g-4">
          <ButtonView type="soft" color="danger" @click="hide(); emit('delete')">
            <i class="fas fa-trash"></i>
          </ButtonView>
          <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
            {{ translate("close") }}
          </ButtonView>
        </div>
      </div>
    </template>
  </TargetedModalView>
</template>

<script setup>
import {InputErrorsView, ButtonView, TargetedModalView, ModalCloseButtonView} from "@niftybit/vue";
import ParameterForm from "@/systems/modules/automation/form/actions/ParameterForm.vue";
import {computed} from "vue";

const props = defineProps({
  communityId: String,
  trigger: Object,
  value: Object,
  actions: Array,
  dataTypes: Array,
  errors: Object
});

const emit = defineEmits(["update:value", "delete"]);

const selectedAction = computed(() => props.actions.find(item => item.key === props.value.key));

function updateValue(callback) {
  let item = JSON.parse(JSON.stringify(props.value));
  callback(item);
  emit("update:value", item);
}
</script>